import { moduleName } from '@/constants/global/module';
import { CustomRouteRecord } from '@/types/router/router';

const meta = {
  moduleName: moduleName.Analytics,
  moduleVersion: '1.0.0',
};

const analyticsRoute: Array<CustomRouteRecord> = [
  {
    path: '/analytics/rfm',
    name: 'analytics-rfm-main',
    component: () => import('@/views/modules/rfm/pages/MainPage.vue'),
    meta: {
      ...meta,
    },
    breadcrumb: [
      {
        text: 'main_menu.analytics',
      },
    ],
  },
  {
    path: '/analytics/rfm/configuration',
    name: 'analytics-rfm-configuration',
    component: () => import('@/views/modules/rfm/pages/ConfigurationPage.vue'),
    meta: {
      ...meta,
    },
    breadcrumb: [
      {
        text: 'main_menu.analytics',
        to: '/analytics/rfm',
      },
      {
        text: 'rfm_configuration',
        active: true,
      },
    ],
  },
  {
    path: '/analytics/rfm/model',
    name: 'analytics-rfm-model',
    component: () => import('@/views/modules/rfm/pages/RFMModelListPage.vue'),
    meta: {
      ...meta,
    },
    breadcrumb: [
      {
        text: 'main_menu.analytics',
        to: '/analytics/rfm',
      },
      {
        text: 'main_menu.analytics_rfm',
        active: true,
      },
    ],
  },
];

export default analyticsRoute;
